// Small utilities shared by the Schedule page (and its hooks).
// Pure functions only — no React.

// Canonical empty state for the FilterBar.
export const EMPTY_FILTERS = {
  rooms: [],
  crew: [],
  priorities: [],
  statuses: [],
  search: "",
  showAllCrew: false,
};

// Sort the two block ids so the same pair always produces the same key
// regardless of which block was assigned first. Used by the double-book
// override Set so the amber stripe shows on every affected row.
export function makeDoubleBookKey(crewId, blockA, blockB) {
  const [a, b] = [blockA, blockB].sort();
  return `${crewId}|${a}|${b}`;
}

// Picks a sensible default day for the MealBreakDialog when the user clicks
// "+ MEAL" from the floating tray (no specific day context). Prefers today
// when it sits inside the project's window, otherwise the project start date.
export function defaultMealDateKey(project) {
  if (!project) return null;
  const today = new Date().toISOString().slice(0, 10);
  if (project.start_date && project.end_date) {
    if (today >= project.start_date && today <= project.end_date) return today;
    return project.start_date;
  }
  return today;
}
